export const css = {
	root: 'HLH2QG4Y',
	chart: '_2_IatJbO',
	' _key': 'charts/charts'
};

export default css;
